export default [

     {
          path: '/initiative',
          name: 'Initiative',
          component: () => import("@/views/Page/Initiative/Initiative.vue"),
          meta: {
               title: 'Initiative',
          },
     }
];